<div class="animate__animated animate__fadeInRight">
    <br />

    <div class="col">
        <mat-card class="mat_card_general">
            <h1 class>Modulo de Jornada Laboral</h1>
        </mat-card>
    </div>

    <br />
    <mat-card class="mat-elevation-z5 mat_card_general_content">
        <app-agregar-jornada-laboral (onDebounce)="actualizarTabla($event)"></app-agregar-jornada-laboral>
        <br />
        <app-lista-jornada-laboral (onDebounce)="actualizarTabla($event)" [jornadas_List]="jornadas"></app-lista-jornada-laboral>
    </mat-card>
    <hr />
</div>